import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/hud-income-limits")({
  component: () => <Outlet />,
});
